import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteMessageSentItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackQuoteMessageSentParameters
    extends TrackEventListParameters<"has_notes" | "type", null, TrackQuoteMessageSentItem> {}

const trackQuoteMessageSent = (
    parameters: TrackQuoteMessageSentParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.eventList({ action: "quote_message_sent", ...parameters }, options);
};

export default trackQuoteMessageSent;
